import { useAppDispatch } from '../AppContext'
import Listen from '../listen/Listen'
import Player from '../player/Player'
import { useModalStack } from './ModalStack'
import '../App.css'
import useCurrentUser from '../hooks/useCurrentUser'
import { Box, Container, Group, Title } from '@mantine/core'
import RoomMemberSummary from '../rooms/RoomMemberSummary'
import ProfileAvatar from '../profile/ProfileAvatar'
import { useState, useEffect } from 'react'
import Joyride, { STATUS } from 'react-joyride'
import useUserIsCurator from '../hooks/useUserIsCurator'

function Main() {
    const dispatch = useAppDispatch()
    global.uiDispatch = dispatch // A cheat to allow us to dispatch directly from Api functions

    const user = useCurrentUser()
    const isCurator = useUserIsCurator()

    const { pushModal } = useModalStack()

    const noteIcon = `${process.env.PUBLIC_URL}/tunistry-note-icon-white.svg`

    // Onboarding tour state
    const [runTour, setRunTour] = useState(false)

    // Check if user needs any onboarding
    const [hasSeenCuratorOnboarding, setHasSeenCuratorOnboarding] = useState(true)
    useEffect(() => {
        if (user?.id) {
            setHasSeenCuratorOnboarding(!!localStorage.getItem(`onboarding-curator-seen-${user.id}`))
        }
    }, [user?.id])
    useEffect(() => {
        if (!hasSeenCuratorOnboarding && isCurator) {
            setTimeout(() => setRunTour(true), 500)
        }
    }, [hasSeenCuratorOnboarding, isCurator])

    const curatorTourSteps = [
        {
            target: '[data-tour="skip-button"]',
            content: "As a curator, you can skip tracks that aren't a good fit for the room using this button.",
            disableBeacon: true,
        },
        {
            target: '[data-tour="room-settings"]',
            content: "Curators can manage room settings.  Click here to view or change the settings for this room.",
            disableBeacon: true,
        },
    ]

    const handleJoyrideCallback = (data) => {
        const { status } = data

        if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
            // Mark onboarding as seen
            if (user?.id) {
                localStorage.setItem(`onboarding-curator-seen-${user.id}`, 'true')
                setHasSeenCuratorOnboarding(true)
            }
            setRunTour(false)
        }
    }

    function openProfile() {
        pushModal('profile')
    }

    return (
        <div className="MainContainer">
            <Joyride
                steps={curatorTourSteps}
                run={runTour}
                continuous
                hideCloseButton
                showSkipButton
                disableOverlayClose
                disableCloseOnEsc
                locale={{ skip: 'Exit', last: 'Finish' }}
                callback={handleJoyrideCallback}
                styles={{
                    options: {
                        primaryColor: '#ec03fc',
                        zIndex: 10000,
                    },
                }}
            />
            <div className="Main">
                <div className="MainContent">
                    <div className="MainHeader">
                        <Box component="header" style={{
                            position: 'relative',
                            zIndex: 1,
                            background: 'rgba(0,0,0,0.25)',
                            backdropFilter: 'blur(4px)',
                            borderBottom: '1px solid rgba(255,255,255,0.08)'
                        }}>
                            <Container fluid size="lg" py="xs">
                                <Group justify="space-between" align="center">
                                    <Group align="center" gap="xs">
                                        <img src={noteIcon} alt="Tunistry note icon" width={24} height={24} style={{ display: 'block' }} />
                                        <Title
                                            order={2}
                                            style={{
                                                margin: 0,
                                                fontSize: 'clamp(18px, 4vw, 24px)',
                                                fontWeight: 700,
                                                fontFamily: 'Cairo, Arial, sans-serif',
                                                letterSpacing: 0.2,
                                            }}
                                        >
                                            Tunistry
                                        </Title>
                                    </Group>
                                    <Group gap="sm" align="center" data-tour="room-members">
                                        <div>
                                            <RoomMemberSummary />
                                        </div>
                                        <div onClick={openProfile} style={{ cursor: 'pointer' }} data-tour="profile-avatar">
                                            <ProfileAvatar user={user} size={30} />
                                        </div>
                                    </Group>
                                </Group>
                            </Container>
                        </Box>
                    </div>
                    <div className="MainTabContent">
                        <div className="MainTabContentScroller">
                            <div className="ActiveTab">
                                <Listen />
                            </div>
                        </div>
                    </div>
                </div>
                <Player className="Player" />
            </div>
        </div>
    )
}


export default Main
